/* angular:styles/component:css;cdea0a4dd0a268605d498311f24bb01b1df2d8691abf63daa8130a39e2bab2bf;/src/src/app/shared/components/formly/formly-field-checkbox-image/formly-field-checkbox-with-image.ts */
.center-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 10rem;
  height: auto;
}
.input-box {
  border: 0.1em solid var(--ion-color-dark);
  border-radius: 0.125rem;
  width: 100%;
  padding-left: 0.5rem;
  --min-height: auto;
  --border-color: var(--ion-color-medium);
  transition: border-color 0.3s;
}
.disabled-sub-field {
  pointer-events: none;
  opacity: 0.5;
}
.help-icon {
  vertical-align: middle;
  font-size: 1.1em;
  margin-left: 0.25rem;
  color: var(--ion-color-medium-shade);
  cursor: help;
}
/*# sourceMappingURL=formly-field-checkbox-with-image.css.map */
